export const comparisonFields = [
    { label: 'Address', key: 'Address', isHigherBetter: false },
    { label: 'Price', key: 'Lp_dol', isHigherBetter: false },
    { label: 'Square Feet', key: 'Sqft', isHigherBetter: true },
    { label: 'Bedrooms', key: 'Br', isHigherBetter: true },
    { label: 'Bathrooms', key: 'Bath_tot', isHigherBetter: true },
    { label: 'Lot Size', key: 'LotSize', isHigherBetter: true },
]